export default {"src":"/_next/static/media/information-petsitter-expert.59e3d832.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};